import { render, staticRenderFns } from "./NewsLatter.vue?vue&type=template&id=79b70d48&"
import script from "./NewsLatter.vue?vue&type=script&lang=js&"
export * from "./NewsLatter.vue?vue&type=script&lang=js&"
import style0 from "./NewsLatter.vue?vue&type=style&index=0&id=79b70d48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports